import { render, staticRenderFns } from "./sqChartTj.vue?vue&type=template&id=1606574a&scoped=true"
import script from "./sqChartTj.vue?vue&type=script&lang=js"
export * from "./sqChartTj.vue?vue&type=script&lang=js"
import style0 from "./sqChartTj.vue?vue&type=style&index=0&id=1606574a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606574a",
  null
  
)

export default component.exports